module.exports = __webpack_public_path__ + "media/images/carousel/banner_12-5f4e4fd71aa87fa0f3deac1adfda46de.jpg";